import { __rest, __assign } from 'tslib';
import React, { useEffect } from 'react';
import { checkStyles } from '@reach/utils';
var id = "reach-skip-nav"; ////////////////////////////////////////////////////////////////////////////////

/**
 * SkipNavLink
 *
 * Renders a link that remains hidden until focused to skip to the main content.
 *
 * @see Docs https://reacttraining.com/reach-ui/skip-nav#skipnavlink
 */

var SkipNavLink = function SkipNavLink(_a) {
  var _b = _a.children,
      children = _b === void 0 ? "Skip to content" : _b,
      props = __rest(_a, ["children"]);

  useEffect(function () {
    return checkStyles("skip-nav");
  }, []);
  return React.createElement("a", __assign({}, props, {
    href: "#" + id,
    "data-reach-skip-link": true
  }), children);
};

SkipNavLink.displayName = "SkipNavLink"; ////////////////////////////////////////////////////////////////////////////////

/**
 * SkipNavContent
 *
 * Renders a div as the target for the link.
 *
 * @see Docs https://reacttraining.com/reach-ui/skip-nav#skipnavcontent
 */

var SkipNavContent = function SkipNavContent(props) {
  return React.createElement("div", __assign({}, props, {
    id: id
  }));
};

SkipNavContent.displayName = "SkipNavContent";
export { SkipNavContent, SkipNavLink };